import cn from 'classnames';

const PLAYER_OPTIONS = {
  rel: 0,
  autoplay: 1,
  mute: 1,
  more: 0,
  modestbranding: 1,
  showinfo: 0,
  iv_load_policy: 3,
};

interface ArticleVideoPlayerProps {
  className?: string;
  videoUrl: string | null;
}
export default function ArticleVideoPlayer({
  className,
  videoUrl,
}: ArticleVideoPlayerProps) {
  if (!videoUrl) {
    return null;
  }

  const playerParams = new URLSearchParams();

  Object.entries(PLAYER_OPTIONS).forEach(([key, value]) => {
    playerParams.set(key, String(value));
  });

  const query = playerParams.toString();

  return (
    <iframe
      className={cn('aspect-video h-auto w-full cmplazyload', className)}
      width={1920}
      height={1080}
      data-cmp-purpose="c56"
      data-cmp-vendor="s30"
      data-cmp-src={`https://www.youtube.com/embed/${videoUrl}?${query}`}
      src="about:blank"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
    />
  );
}
